import React, { useEffect, useCallback } from "react";
import NotificationAlert from "react-notification-alert";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { useParams, useHistory } from "react-router-dom";
import {
  marcheImsAdded,
  marcheImsGetById, marcheLigneGetById
} from "../../../Redux/marcheImsReduce";
import Select from "react-select";



import { useDispatch } from "react-redux";

function AjouterMarcheIms({client}) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  if (isNaN(location.id) === true) document.title = "Ajouter un marché";
  else document.title = "Modifier le marché";
  const [lib, setLib] = React.useState("");
  const [pole, setPole] = React.useState("");
  const [afficher, setAfficher] = React.useState(0);
  const [id, setId] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [alert, setAlert] = React.useState(null);

  const [optionsType] = React.useState([
    {
      value: "",
      label: "Type",
      isDisabled: true,
    },
    {
      value: "PDUIT",
      label: "PDUIT",
    },
  ]);

  const [optionsPole, setOptionsPole] = React.useState([
    {
      value: "",
      label: "Pole",
      isDisabled: true,
    },
  ]);
  const [poleSelect, setPoleSelect] = React.useState({
    value: 0,
    label: "Pole",
  });
  const [idPole, setIdPole] = React.useState(0);


  const notificationAlertRef = React.useRef(null);

  const notify = (place, msg, type) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{msg}</div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };
  function submitForm(event) {
    var id_pole = poleSelect.value;
    if (lib === "") notify("tr", "Marché est obligatoire", "danger");
    else {
      dispatch(marcheImsAdded({ data, lib, afficher, pole, id, id_pole })).then((e) => {
        if (e.payload === true) {
          if (isNaN(location.id) === true)
            notify("tr", "Insertion avec succes", "success");
          else notify("tr", "Modifier avec succes", "success");
          setTimeout(async () => {
            listeMarcheIms();
          }, 1500);
        } else {
          notify("tr", "Problème de connexion", "danger");
        }
      });
    }
  }

  // const getPoles = useCallback(
  //   async (p) => {
  //     var poless = await dispatch(fetchPoles());
  //     var entities = poless.payload;
  //     var arrayOption = [];
  //     entities.forEach((e) => {
  //       arrayOption.push({ value: e.id, label: e.nom });
  //       if (e.id === p) {
  //         setPoleSelect({ value: e.id, label: e.nom });
  //       }
  //     });
  //     setOptionsPole(arrayOption);
  //   },
  //   [dispatch]
  // );

  // useEffect(() => {
  //   async function getMarcheIms() {
  //     if (isNaN(location.id) === false) {
  //       var marcheIms = await dispatch(marcheImsGetById(location.id));
  //       var entities = marcheIms.payload;
  //       if (entities === false) {
  //         navigate.push(client+"/listMarcheIms");
  //       } else {
  //         setLib(entities.lib);
  //         setAfficher(entities.afficher);
  //         setPole(entities.pole);
  //         setId(location.id);
  //       }
  //     }
  //   }
  //   getMarcheIms();
  // }, [location.id, dispatch, navigate]);

  useEffect(() => {

    const promise = new Promise((resolve, reject) => {
      setTimeout(async () => {
        if (isNaN(location.id) === false) {
          var marcheIms = await dispatch(marcheImsGetById(location.id));
          var entities = marcheIms.payload;
          if (entities === false) {
            navigate.push(client+"/listFournisseur");
          } else {
            var paraLigne = await dispatch(marcheLigneGetById(location.id));
            var paraLigneEntities = paraLigne.payload;
            setLib(entities.lib);
            setAfficher(entities.afficher);
            // setPole(entities.pole);
            setId(location.id);
            // setIdPole(entities.poleId);
            var arrayLigne = []
            if (paraLigneEntities.length > 0) {
              paraLigneEntities.forEach(element => {
                arrayLigne.push({ id: element.id, nom_produit: element.nom_produit, type: element.type, typeSelect: { label: element.type, value: element.type } })
              });

            }
            setData(arrayLigne);
            resolve(entities);
          }
        } else {
          resolve(0);
        }
      }, 300);
    });

    promise.then((value) => {
     

    });
  }, [location.id, dispatch, navigate]);


  function listeMarcheIms() {
    navigate.push(client+"/listMarcheIms");
  }


  const hideAlert = () => {
    setAlert(null);
  };
  const confirmMessage = (id) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Êtes-vous sûr de supprimer?"
        onConfirm={() => deleteLigne(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      ></SweetAlert>
    );
  };
  function deleteLigne(id) {
    var list = [...data];
    list.splice(parseInt(id), 1);
    setData(list);
    notify("tr", "Supprimer avec succes", "success");
    hideAlert();
  }

  function AjoutLigne(event) {
    var list = [];
    if (data.length > 0) list = [...data];
    list[list.length] = {
      id: null,
      nom_produit: null,
      typeSelect: null,
      type: null,
    };
    setData(list);
  }



  return (
    <>
      <Container fluid>
        {alert}
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <div className="section-image">
          <Container>
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={listeMarcheIms}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  Retour à la liste
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Header>
                        <Card.Title as="h4">
                          {typeof location.id == "undefined"
                            ? "Ajouter marché"
                            : "Modifier marché"}
                        </Card.Title>
                      </Card.Header>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>Marché * </label>
                            <Form.Control
                              defaultValue={lib}
                              placeholder="Marché"
                              type="text"
                              onChange={(value) => {
                                setLib(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col className="pl-1" md="6">
                          <br></br>

                          <Form.Group className="pull-left">
                            <Form.Check className="pull-right">
                              <Form.Check.Label>
                                <Form.Check.Input
                                  type="checkbox"
                                  checked={afficher === 1 ? true : false}
                                  onClick={(value) => {
                                    if (value.target.checked) {
                                      setAfficher(1);
                                    } else {
                                      setAfficher(0);
                                    }
                                  }}
                                ></Form.Check.Input>
                                <span className="form-check-sign"></span>
                                <label>Afficher</label>
                              </Form.Check.Label>
                            </Form.Check>
                          </Form.Group>
                        </Col>
                      </Row>
             

                      <Row>
                        <Col md="12">
                          <hr></hr>
                          <br></br>
                          <Button
                            className="btn-fill pull-right"
                            type="button"
                            variant="info"
                            nom="redac"
                            onClick={(ev) => AjoutLigne()}
                          >
                            <i className="fas fa-plus"></i> Ajouter
                          </Button>
                          <br></br>
                          <table className="table"  >
                            <thead>
                              <tr>
                                <th>Produit IMS </th>
                                <th>Type</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.length > 0 ? data.map((val, key) => {
                                return (
                                  <tr key={key}>
                                    <td>
                                      <Form.Group>
                                        <label>Produit IMS * </label>
                                        <Form.Control
                                          placeholder="Produit IMS "
                                          value={val.nom_produit}
                                          onBlur={(value) => {
                                            var list = [...data];
                                            list[key] = {
                                              ...list[key],
                                              nom_produit: value.target.value,
                                            };
                                            setData(list);
                                          }}
                                        />
                                      </Form.Group>
                                    </td>
                                    <td>
                                      {val.typeSelect == null ?
                                        (<Form.Group>
                                          <label>Type * </label>
                                          <Select
                                            className="react-select primary"
                                            classNamePrefix="react-select"
                                            name="singleSelect"
                                            value={val.typeSelect}
                                            onChange={(value) => {
                                              var list = [...data];
                                              list[key] = {
                                                ...list[key],
                                                type: value.value,
                                                typeSelect: value,
                                              };
                                              setData(list);
                                            }}
                                            options={optionsType}
                                            placeholder="type"
                                          />
                                        </Form.Group>) : <Form.Group>
                                          <label>Type * </label>
                                          <Form.Control
                                            defaultValue={val.typeSelect.label}
                                            placeholder="Type"
                                            readOnly
                                          ></Form.Control>
                                        </Form.Group>}
                                    </td>
                                    <td>
                                      <div className="actions-right block_action">
                                        <Button
                                          onClick={(ev) => {
                                            confirmMessage(key);
                                          }}
                                          variant="danger"
                                          size="sm"
                                          className="text-danger btn-link delete"
                                        >
                                          <i className="fa fa-trash" />
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }) : <tr><td></td></tr>}
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                      <br></br>
                      <Button
                        className="btn-fill pull-right"
                        type="button"
                        variant="info"
                        onClick={submitForm}
                      >
                        Enregistrer
                      </Button>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </>
  );
}

export default AjouterMarcheIms;
